import {atom, selectorFamily} from 'recoil';
import {ToastHelpers} from '../../../shared/helpers/toastHelpers';
import {serialize} from '../../../shared/utils/serialize-query-params';
import {api} from '../../api';
import {createQuery} from '../../lib';

const {getCompanies} = api.companies;

const getCompaniesRefresh = atom<number>({
  key: 'getCompaniesRefresh',
  default: 0,
});

const getCompaniesQuery = selectorFamily({
  key: 'getCompanies',
  get(params: Parameters<typeof getCompanies>[0]) {
    return async ({get}) => {
      get(getCompaniesRefresh);
      try {
        const {data} = await getCompanies(params, {paramsSerializer: {serialize}});
        return data;
      } catch (e) {
        ToastHelpers.error(e);
        return null;
      }
    };
  },
});

export const useGetCompaniesQuery = createQuery(getCompaniesQuery, getCompaniesRefresh);
